module.exports = __webpack_public_path__ + "img/mtzncxdwxt.1ea72f2b.png";